<template>
  <nav class="nav-bar" :class="{ 'scrolled': isScrolled }">
    <h3 class="nav-title">Join My Journey</h3>
    <ul class="nav-list">
      <li
        class="nav-item"
        v-for="(link, index) in links"
        :key="index"
        :style="getAnimationStyle(index)"
      >
        <router-link
          v-if="link.path"
          :to="link.path"
          class="nav-link"
        >
          {{ link.name }}
        </router-link>
        <a
          v-else
          :href="link.href"
          target="_blank"
          class="nav-link"
        >
          {{ link.name }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
      links: [
        { name: 'Home', path: '/' },
        { name: 'About Me', path: '/about' },
        { name: 'Contact', path: '/contact' },
        // { name: 'Reviews', path: '/reviews' },
        { name: 'I write here', href: 'https://jeromejbrown.substack.com/' },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    getAnimationStyle(index) {
      return {
        animation: `fadeSlideIn 0.5s ease-out ${index * 0.1}s`,
        'animation-fill-mode': 'both',
      };
    },
  },
};
</script>

<style scoped>
/* Navigation Sidebar */
.nav-bar {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: background 0.3s ease;
  z-index: 10;
}

.nav-bar.scrolled {
  background: rgba(255, 255, 255, 0.2);
}

.nav-title {
  font-size: 1.2rem;
  color: #FFFFFF;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
}

/* Nav list */
.nav-list {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  color: #E5E7EB;
  font-size: 1rem;
  font-weight: 400;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
  transition: color 0.3s ease, transform 0.3s ease;
}

.nav-link:hover {
  color: #2DD4BF;
  transform: translateX(5px);
}

/* Fade and slide-in animation */
@keyframes fadeSlideIn {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>